// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__aQ9_f","actionsCol":"EnrolledClinics_actionsCol__-159O"};